import axios from "../api";
// Settle entitlements after a mobile purchase instead of waiting on the
// RevenueCat webhook. Keyed on the authenticated user (JWT sub == backend uuid).
export const verifyRevenueCatEntitlements = async () => {
    const res = await axios.post("/payments/revenuecat/verify");
    return res.data;
};
//# sourceMappingURL=verifyRevenueCat.js.map